import { Size } from '../types/size'

export const sizeToHeight: Record<Size, number> = {
  default: 8,
  small: 4,
}
